import React, {createContext, useContext, useEffect, useState} from "react";
import Tab, {TabGroup} from "@amzn/meridian/tab";
import {DWELL_ROUTES} from "../commons/constants/RouteConstants";
import {Route, Switch} from "react-router-dom";
import DwellingView from "./dwelling/DwellingView";
import SDDwellingView from "./sdDwelling/SDDwellingView";
import {FormattedMessage} from "react-intl";
import Column from "@amzn/meridian/column";
import PageHeader from "../commons/PageHeader";
import {ACTION_TYPE, FEATURES, FIVE_AND_THREE_HOUR, FIVE_AND_THREE_HOUR_BUTTON_TEXT, ONE_HOUR, ONE_HOUR_BUTTON_TEXT, PAGE_HEADERS} from "../commons/constants/CommonConstants";
import {getFeaturesFromParent} from "../handler/ParentDataHandler";
import {chainWalk} from "../commons/CommonUtils";
import {FeatureConfigContext} from "../commons/context/FeatureConfigContext";
import {useDeviceLayout} from "../commons/context/DeviceLayoutContext";
import ButtonGroup, { ButtonOption } from "@amzn/meridian/button-group";
import ViewDataContextProvider from "../commons/context/view/ViewDataContext";
import DwellFilterContextProvider from "../commons/context/DwellFilterContext";
import DwellDetailedView from "./dwellRush/DwellDetailedView";
import DwellOverallStatus from "./dwellRush/DwellOverallStatus";
import DwellDetailedViewFilter from "./dwellRush/DwellDetailedViewFilter";

export const FilterOneHourPackageContext = createContext();

const DwellTabs = (props) => {
    
    // This flag shows whether to enable this new dwell UI feature or not
    const [isDwellDetailedViewEnable, setIsDwellDetailedViewEnable] = useState();
    const [isToggleForDwellDetailedViewEnable, setIsToggleForDwellDetailedViewEnable] = useState();
    
    const [state, setState] = useState();
    const [selectedTabForPackages, setSelectedTabForPackages] = useState(FIVE_AND_THREE_HOUR);
    const {configViewModel, configDispatch} = useContext(FeatureConfigContext)
    const {spacingInset_shorthand2} = useDeviceLayout();
    const onTabChange = (selectedTab) => {
        setState(selectedTab);
        props.history.push(DWELL_ROUTES[selectedTab].path)
    };

    useEffect(()=> {
        getFeaturesFromParent([FEATURES.IS_CPT_FILTER_ENABLED, FEATURES.IS_DWELL_DETAILED_VIEW_FOR_SSD_ENABLED, FEATURES.IS_PACKAGE_TYPE_COLUMN_DWELL_ENABLED, 
            FEATURES.IS_TOGGLE_FOR_DWELL_DETAILED_VIEW_ENABLED, FEATURES.IS_SHIP_OPTION_FILTER_FOR_METRICS_API_ENABLED,
            FEATURES.IS_SHIP_OPTION_FILTER_FOR_EXPORT_API_ENABLED, FEATURES.IS_SHIP_OPTION_FILTER_FOR_DRILL_DOWN_API_ENABLED]).then(featureStatus => {
            configDispatch({type: ACTION_TYPE.GET_FEATURES_STATUS, featureStatus: featureStatus.data});
            setIsDwellDetailedViewEnable(chainWalk(() => featureStatus.data[FEATURES.IS_DWELL_DETAILED_VIEW_FOR_SSD_ENABLED], false));
            setIsToggleForDwellDetailedViewEnable(chainWalk(() => featureStatus.data[FEATURES.IS_TOGGLE_FOR_DWELL_DETAILED_VIEW_ENABLED], false));
        })
        
        Object.keys(DWELL_ROUTES).some((key) => {
            if(props.location.pathname.includes(DWELL_ROUTES[key].path)) {
                setState(key);
                return true;
            }
            return false;
        })
    },[props.location.pathname]);
    
    const isCPTFilterEnabled = chainWalk(() => configViewModel.featureStatus[FEATURES.IS_CPT_FILTER_ENABLED], false);
    
    const DwellConciseView = () => {    
        return (
        
            <React.Fragment>
                <TabGroup value={state} onChange={onTabChange} fill="line">
                    {!isCPTFilterEnabled? <Tab value={"dwell"}>
                        <FormattedMessage id="dwell.by_cycle" defaultMessage="By Cycle"/>
                    </Tab>: <Tab value={"dwell"}>
                        <FormattedMessage id="dwell.by_dispatch" defaultMessage="By Dispatch-by Time"/>
                    </Tab>}

                    <Tab value={"sddwell"}>
                        <FormattedMessage id="dwell.by_sd_window" defaultMessage="By Scheduled Delivery Window"/>
                    </Tab>
                </TabGroup>
                <Switch>
                    <Route exact path="/dwellingBoard/sd/:context?" component={SDDwellingView} />
                    <Route exact path="/dwellingBoard/:context?" component={DwellingView} />
                </Switch>
            </React.Fragment>
        );
    }
    const dwellDetailedView = () => {
        return (
            <ViewDataContextProvider>
                <DwellFilterContextProvider>
                    <DwellDetailedViewFilter selectedTabForPackages={selectedTabForPackages} />
                    <DwellOverallStatus selectedTabForPackages={selectedTabForPackages} />
                    <DwellDetailedView selectedTabForPackages={selectedTabForPackages} location={props.location}> </DwellDetailedView>
                </DwellFilterContextProvider>
            </ViewDataContextProvider>);
    }

    const dwellDetailedTableView = () => {
        return (
            <React.Fragment>
                {
                    ((isToggleForDwellDetailedViewEnable === null || isToggleForDwellDetailedViewEnable === undefined || !isToggleForDwellDetailedViewEnable) ? null : (
                        <ButtonGroup value={selectedTabForPackages} onChange={setSelectedTabForPackages}>
                            <ButtonOption key="12" value={FIVE_AND_THREE_HOUR}>
                                <FormattedMessage id="dwell.byfivehour" defaultMessage={FIVE_AND_THREE_HOUR_BUTTON_TEXT}/>
                            </ButtonOption>
                            <ButtonOption key="12" value={ONE_HOUR}>
                                <FormattedMessage id="dwell.byonehour" defaultMessage={ONE_HOUR_BUTTON_TEXT}/>
                            </ButtonOption>
                        </ButtonGroup>
                    ))
                }
                {
                    dwellDetailedView()
                }
            </React.Fragment>
        );
    }

    return (
        <Column spacing={"small"} spacingInset={spacingInset_shorthand2}>
            <PageHeader {...PAGE_HEADERS.DWELL}/>
            {
                (isDwellDetailedViewEnable === null || isDwellDetailedViewEnable === undefined) ? null :(
                    <FilterOneHourPackageContext.Provider value={isDwellDetailedViewEnable}>
                        {isDwellDetailedViewEnable ? 
                        (
                            dwellDetailedTableView()
                        ):
                        (
                            DwellConciseView()
                        )}
                    </FilterOneHourPackageContext.Provider>
                )
            }
        </Column>
    )
};

export default DwellTabs


// WEBPACK FOOTER //
// ./src/components/DwellTabs.js